import React, { useEffect, useState } from "react";

export const Question = ({data, sendAnswers, isAnswerOpen}) => {
    const [userAnswers, setUserAnswers] = useState([]);
    const [isBtnDisabled, setIsBtnDisabled] = useState(true);

    const toggleItem = (item) => {
        if(!isAnswerOpen){
            if(userAnswers.includes(item)){
                setUserAnswers([...userAnswers.filter(r => r !== item)])
            } else {
                setUserAnswers([...userAnswers, item])
            }
        }
    }

    useEffect(() => {
        data && setUserAnswers([]);
    }, [data])

    useEffect(() => {
        userAnswers.length > 0 && !isAnswerOpen && setIsBtnDisabled(false);
    }, [userAnswers])

    const send = () => {
        setIsBtnDisabled(true);
        sendAnswers(userAnswers);
    }

    return (
        <>
            <div className="form-group-version2" role="radiogroup" aria-labelledby="group-radio-0" tabindex="-1">
                <h2 className="field-label heading type-edito-3" id="group-radio-0"><strong>{data.question}</strong></h2>
                <div className="field-item -form-check-version2 -vertical d-flex align-items-stretch mt-4 flex-column flex-md-row">
                    {data.suggestedAnswers && data.suggestedAnswers.map((s, index) =>
                        <div className="p-2 question-item">
                            <div className="item">
                                {data.answerType === 'radio'
                                    ? <input id={`input-${index}`} type="radio" checked={userAnswers.includes(s)} onClick={() => !isAnswerOpen && setUserAnswers([s])}/>
                                    : <input id={`input-${index}`} type="checkbox" checked={userAnswers.includes(s)} onClick={() => toggleItem(s)} />
                                }
                                <label for={`input-${index}`}>
                                    <span>{s}</span>
                                </label>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className={`step-action -horizontal-sm -vertical ${isAnswerOpen ? 'd-none' : ''}`}>
                <button className={`button -primary py-2 mt-2 mb-5 ${isBtnDisabled ? '-disabled' : ''}`} title="Voir la réponse" onClick={send}>Voir la réponse</button>
            </div>
        </>
    )
}